import React from 'react';
import Scheduler from '../CRUDUtils/SchedulePage';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { Button, Space } from 'antd';
import {useDeploymentListStore } from '../../store';


export default function SchedulePage() {
    const { deployment_id, location_name } = useParams();
    return (
        <Scheduler
            key={deployment_id} // forces full remount on navigation
            deployment_key={deployment_id}
            createEndpoint={`create/schedules?deployment_id=${deployment_id}`}
            readEndpoint={`read/schedules?deployment_id=${deployment_id}`}
            editEndpoint={`update/schedules?deployment_id=${deployment_id}`}
            deleteEndpoint={`delete/schedules?deployment_id=${deployment_id}`}
            detectionPackagesEndpoint="read/detectionpackages"
            location_name={`Site: ${location_name}`}
        />
    );
}
